var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FDC954"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2671 4L11.0455 12.1477H8.96599L8.73871 4H11.2671ZM10.0043 16.4547C9.62934 16.4547 9.30737 16.3221 9.03843 16.0569C8.76949 15.788 8.63692 15.466 8.6407 15.091C8.63692 14.7198 8.76949 14.4016 9.03843 14.1365C9.30737 13.8713 9.62934 13.7387 10.0043 13.7387C10.3642 13.7387 10.6805 13.8713 10.9532 14.1365C11.2259 14.4016 11.3642 14.7198 11.368 15.091C11.3642 15.341 11.2979 15.5702 11.1691 15.7785C11.0441 15.9831 10.8793 16.1478 10.6748 16.2728C10.4702 16.3941 10.2468 16.4547 10.0043 16.4547Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.58e71656aba0796dd84cab23e5ec3e7c.svg";
export { ForwardRef as ReactComponent };